var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 7C5.26669 7 4.66669 6.4 4.66669 5.66667C4.66669 4.93333 5.26669 4.33333 6.00002 4.33333C6.73335 4.33333 7.33335 4.93333 7.33335 5.66667C7.33335 6.4 6.73335 7 6.00002 7ZM6.00002 0.333334C3.20002 0.333334 0.666687 2.48 0.666687 5.8C0.666687 8.01333 2.44669 10.6333 6.00002 13.6667C9.55335 10.6333 11.3334 8.01333 11.3334 5.8C11.3334 2.48 8.80002 0.333334 6.00002 0.333334Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPlace);
export default __webpack_public_path__ + "static/media/picto-place.9c3787bfa8d8a0f509b62dc147b881f4.svg";
export { ForwardRef as ReactComponent };